import api from './api';

export const getEmployeeContracts = (employeeId) => api.get(`/contracts/employee/${employeeId}`);

export default { getEmployeeContracts };
